import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [성능/운영>요약] 선택한 장비에 대한 운영상태 정보 조회
   * @author jeee12
   * @param  {Object} params
   * @return {Object}        선택한 장비에 대한 운영상태 정보
   */
  getOperationStateInfo(params) {
    return axios.post(`${baseUrl}/performance/summary/get-device-operation-state.do`, params);
  },
  /**
   * [성능/운영>요약] 선택한 장비에 대한 이벤트 정보 조회
   * @author kimjy
   * @param  {Object} params
   * @return {Object}        선택한 장비에 대한 이벤트 정보
   */
  getSummaryEventInfo(params) {
    return axios.post(`${baseUrl}/performance/summary/get-event-info.do`, params);
  },
  /**
   * 장비 가동률 팝업 기간별 컬럼차트 (일간, 주간, 월간, 연간) 정보 조회
   * @author Song
   * @param  {Object} params
   * @return {Object}        선택한 장비에 대한 가동률 정보
   */
  getAvailableHist(params) {
    return axios.post(`${baseUrl}/performance/summary/get-available-hist.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/summary/summary-info.js